import { useCallback, useMemo } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

export const StarfieldBackground = () => {
    const particlesInit = useCallback(async (engine) => {
        await loadSlim(engine);
    }, []);

    const options = useMemo(() => ({
        fullScreen: {
            enable: true,
            zIndex: 0
        },
        background: {
            color: {
                value: "transparent"
            }
        },
        fpsLimit: 60,
        particles: {
            number: {
                value: 120,
                density: {
                    enable: true,
                    value_area: 1000
                }
            },
            color: {
                value: ["#D4AF37", "#F5F5F5", "#A89340", "#FFFFFF"]
            },
            shape: {
                type: "circle"
            },
            opacity: {
                value: { min: 0.1, max: 0.8 },
                animation: {
                    enable: true,
                    speed: 0.5,
                    minimumValue: 0.1,
                    sync: false
                }
            },
            size: {
                value: { min: 0.5, max: 2.5 },
                animation: {
                    enable: true,
                    speed: 1,
                    minimumValue: 0.5,
                    sync: false
                }
            },
            move: {
                enable: true,
                speed: 0.2,
                direction: "none",
                random: true,
                straight: false,
                outModes: {
                    default: "out"
                }
            },
            twinkle: {
                particles: {
                    enable: true,
                    frequency: 0.03,
                    opacity: 1,
                    color: {
                        value: "#D4AF37"
                    }
                }
            }
        },
        interactivity: {
            detectsOn: "canvas",
            events: {
                onHover: {
                    enable: true,
                    mode: "grab"
                },
                resize: true
            },
            modes: {
                grab: {
                    distance: 150,
                    links: {
                        opacity: 0.2,
                        color: "#D4AF37"
                    }
                }
            }
        },
        detectRetina: true
    }), []);

    return (
        <Particles
            id="tsparticles"
            init={particlesInit}
            options={options}
            className="fixed inset-0 pointer-events-none"
        />
    );
};

export default StarfieldBackground;
